<template>
  <DialogLayout
    title="料金計算"
    :visible.sync="dialogVisible"
    width="45em"
    @open="open"
  >
    <template #form>
      <CalculationForm
        ref="calculationForm"
        v-model="calculationFormModel"
        action="/calculation-fees-for-weight-and-noise"
        billingYmMode="this"
      />
    </template>
    <template #footer>
      <CalculationDialogFooter
        @calculation="clickCalculation"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import CalculationForm from '@/components/organisms/dialog/CalculationForm.vue'
import CalculationDialogFooter from '@/components/organisms/dialog/CalculationDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    CalculationForm,
    CalculationDialogFooter
  },
  mixins: [
  ],
  props: {
    visible: Boolean
  },
  data () {
    return {
      calculationFormModel: {
        billing_ym: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterRegisterDialog.mounted')
  },
  methods: {
    /* clickCalculation () {
      console.log('clickCalculation')
      this.$loadingMask.on()
      this.$refs.calculationForm.validate()
        .then((res) => {
          this.$refs.calculationForm.calculation()
        })
        .catch((e) => {
          console.log(e)
          this.$loadingMask.off()
        })
    }, */
    clickCalculation () {
      this.$loadingMask.on()
      const params = { ...this.calculationFormModel }
      this.$refs.calculationForm.validate()
        .then((valid) => {
          return this.$axios.put('/calculation-fees-for-weight-and-noise', params)
        })
        .then((res) => {
          if (res.status === 202) {
            this.$fcMessage.showMessage({
              id: 'CAL0001I',
              link: {
                fileName: 'warning.txt',
                messages: res.data.message
              }
            }, true)
          } else {
            this.$fcMessage.showMessage(res.data.message)
          }
          this.dialogVisible = false
          this.$emit('refresh', this.calculationFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      console.log('FeesForWeightAndNoiseCalculationDialog.open')
      this.$nextTick(function () {
        console.log(this.$refs.calculationForm)
        this.$refs.calculationForm.clear()
      })
    }
  }
}
</script>

<style lang="scss">
</style>
